import { render, staticRenderFns } from "./FlagSvg.vue?vue&type=template&id=2ea65f83"
import script from "./FlagSvg.vue?vue&type=script&lang=js"
export * from "./FlagSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports